import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatTableModule} from "@angular/material/table";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {PermissionTypes} from "../../../enum/PermissionTypes";

export interface RoleTableColumn {
  key: string;
  header: string;
  getValue: (item: any) => string;
}

@Component({
  selector: 'app-role-table',
  standalone: true,
  imports: [
    MatTableModule,
    MatIconButton,
    MatIcon,
    MatTooltip,
    HasPermissionDirective
  ],
  templateUrl: './role-table.component.html',
  styleUrl: './role-table.component.scss'
})
export class RoleTableComponent {
  @Input() dataSource: any[] = [];
  @Input() columns: RoleTableColumn[] = [];
  @Input() removeTooltip = 'Remove';
  @Input() removeAriaLabel = 'Remove item';
  @Input() testIdPrefix = 'role';

  @Output() remove = new EventEmitter<any>();

  protected readonly PermissionTypes = PermissionTypes;

  get displayedColumns(): string[] {
    return [...this.columns.map(c => c.key), 'actions'];
  }

  onRemoveClick(item: any) {
    this.remove.emit(item);
  }
}
